<template>
  <v-select
    v-model="selectedPaymentstatus"
    :items="paymentsStatusesList"
    item-text="text"
    item-value="id"
    placeholder="Estatus pago"
    outlined
    dense
    :clearable="clearable"
    multiple
  >
  </v-select>
</template>

<script>
import { computed, onMounted } from '@vue/composition-api'
import usePaymentsStatusesList from '@/components/lists/paymentsStatuses'

export default {
  props: {
    default: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Array,
      default: () => [],
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { paymentsStatusesList } = usePaymentsStatusesList()
    const selectedPaymentstatus = computed({
      get() {
        return props.value
      },
      set(value) {
        // Actualiza el valor del componente y emite el evento "input"
        // para mantener sincronizado el valor con v-model
        return emit('input', value)
      },
    })

    const Reset = () => {
      emit('input', props.default)
    }

    onMounted(() => {
      Reset()
    })

    return {
      selectedPaymentstatus,
      paymentsStatusesList,
      Reset,
    }
  },
}
</script>
